module.exports = __webpack_public_path__ + "img/oryx.83679b83.png";